<template>
  <v-flex xs12> 
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <CardSeparador :router="`/practica/intermedio/${idUnidad}/ejercicio/lectura`" descripcion="Responda correctamente después de leer el siguiente texto." :image="require('@/assets/images/practica/practicaImagen.png')"/>
  </v-flex>
</template>

<script>
import CardSeparador from '../../../components/Practica/Global/CardSeparador'
export default {
  name: 'PracticaSeparador',
  props: ['idUnidad'],
  components: {
    CardSeparador
  }
}
</script>
